import { getDeviceDataFromMapping } from './devices';
import { getDeviceSn } from './helpers';

export const mergeSubsAndDevices = (subsData, devicesData) => {
  if (!subsData?.subscriptions) {
    return [];
  }

  return subsData.subscriptions.map((sub) =>
    injectDeviceIntoSub(sub, devicesData),
  );
};

export const injectDeviceIntoSub = (sub, devicesData) => {
  const deviceSn = getDeviceSn(sub.properties);

  const deviceData = devicesData ? devicesData[deviceSn] : false;

  const mappedDeviceData = getDeviceDataFromMapping(
    deviceData?.device_info?.device_type_name || sub.product_title,
  );

  return {
    ...sub,
    meta: {
      ...mappedDeviceData,
      ...deviceData,
    },
    device_sn: deviceSn,
  };
};

export const sortSubscriptions = (subs) => {
  subs.sort((a, b) => {
    const aDeviceSn = getDeviceSn(a.properties);
    const bDeviceSn = getDeviceSn(b.properties);
    const aStatus = !!a.cancelled_at;
    const bStatus = !!b.cancelled_at;
    if ((!aDeviceSn || aStatus) && (!bDeviceSn || bStatus)) {
      return 0;
    } else if ((!aDeviceSn || aStatus) && !(!bDeviceSn || bStatus)) {
      return 1;
    } else {
      return -1;
    }
  });
  return subs;
};

export const isSubException = (sub) => {
  if (!sub.product_title) {
    return true;
  }

  const excludedWords = [
    '5g',
    'vz',
    'test',
    'warranty',
    'titan',
    'edge',
    'protection',
  ];
  const titleContainsExcludedWord = excludedWords.some((word) =>
    sub.product_title.toLowerCase().split(' ').includes(word),
  );

  if (titleContainsExcludedWord) return true;

  if (sub.variant_title) {
    const variantContainsExcludedWord = excludedWords.some((word) =>
      sub.variant_title.toLowerCase().split(' ').includes(word),
    );
    if (variantContainsExcludedWord) return true;
  }

  return false;
};

export const mergeSubsAndProducts = (subs, productsData) => {
  if (!subs?.length) {
    return [];
  }
  return subs.map((sub) => {
    const productId = sub?.external_product_id?.ecommerce;
    const productData = productsData?.products?.find((product) => {
      return product.external_product_id === productId;
    });

    return {
      ...sub,
      meta: {
        ...sub?.meta,
        productInfo: productData,
      },
    };
  });
};

/**
 * Check if rc sub relates to verizon product
 * @param sub recharge sub
 * @returns { boolean }
 */
export const isVzSub = (sub) => {
  const includedWords = ['5g', 'vz', 'titan', 'edge'];
  const titleContainWord = includedWords.some((word) =>
    sub.product_title.toLowerCase().split(' ').includes(word),
  );

  if (titleContainWord) return true;

  if (sub.variant_title) {
    const variantContainsWord = includedWords.some((word) =>
      sub.variant_title.toLowerCase().split(' ').includes(word),
    );
    if (variantContainsWord) return true;
  }

  return false;
};
